import React, { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { getToken } from "../software/api";
import { queue, shrink, fileUrl } from "./techData";

const SLOTS = [["equipment_image_url", "Pool Equipment"], ["pool_image_url", "Body of Water"]];

// the two standing photos on the client's body of water - the same pictures as the desktop Water Test tab
export default function BodyPhotos({ body, clientId, onSaved }) {
  const pick = useRef(null), [slot, setSlot] = useState(null), [busy, setBusy] = useState(""), [err, setErr] = useState("");
  const upload = async (file) => {
    const field = slot; setErr(""); setBusy(field);
    try {
      const fd = new FormData(); fd.append("file", await shrink(file), "photo.jpg");
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/uploads`, { method: "POST", headers: { Authorization: `Bearer ${getToken()}` }, body: fd });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Upload failed");
      queue(`wb:${body.id}:${field}`, "PATCH", `/waterbodies/${body.id}`, { [field]: d.url });
      const k = `tc:/tech/client/${clientId}`, c = JSON.parse(localStorage.getItem(k) || "null");
      if (c) localStorage.setItem(k, JSON.stringify({ ...c, bodies: (c.bodies || []).map((b) => (b.id === body.id ? { ...b, [field]: d.url } : b)) }));
      onSaved({ [field]: d.url });
    } catch (e) { setErr(navigator.onLine ? e.message : "Saving a photo needs phone signal"); }
    setBusy("");
  };
  return (
    <div className="space-y-2 pt-2" data-testid="tech-body-photos">
      <input ref={pick} type="file" accept="image/*" capture="environment" hidden data-testid="tech-body-photo-input"
        onChange={(e) => { const f = e.target.files[0]; e.target.value = ""; if (f) upload(f); }} />
      {err && <div className="text-red-700 font-bold text-[15px]" data-testid="tech-body-photo-error">{err}</div>}
      <div className="grid grid-cols-2 gap-3">
        {SLOTS.map(([field, label]) => (
          <button key={field} onClick={() => { setSlot(field); pick.current.click(); }} data-testid={`tech-body-photo-${field}`}
            className="rounded-2xl bg-white shadow-sm overflow-hidden flex flex-col active:scale-[0.98] transition-transform">
            <span className="py-1.5 text-[15px] font-black text-[#0f2f52]">{label}</span>
            <span className="aspect-[4/3] bg-white border-2 border-dashed border-slate-300 rounded-b-2xl flex items-center justify-center overflow-hidden">
              {busy === field ? <Loader2 className="h-8 w-8 animate-spin text-cyan-700" />
                : body[field] ? <img src={fileUrl(body[field])} alt={label} className="w-full h-full object-cover" data-testid={`tech-body-photo-img-${field}`} />
                  : <span className="flex flex-col items-center gap-1 text-slate-400 text-[13px] font-bold"><Camera className="h-8 w-8" />Take photo</span>}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
